<template>
  <div>
    <div class="content">
      <ul>
        <li>
          <span>食堂：</span>
          <span>{{ orderInfo.name }}</span>
        </li>
        <li>
          <div>
            <p>
              <span>姓名：</span>
              <span>{{ orderInfo.patientName }}</span>
            </p>
            <p>
              <span>床位号：</span>
              <span>{{ orderInfo.bedNo }}</span>
            </p>
          </div>
        </li>
        <li>
          <div>
            <p>
              <span>住院号：</span>
              <span>{{ orderInfo.hospitalNo }}</span>
            </p>
          </div>
        </li>
        <li>
          <div>
            <p>
              <span>配餐员：</span>
              <span>{{ orderInfo.directorName }}</span>
            </p>
            <p>
              <span>联系电话：</span>
              <span>{{ orderInfo.directorMobile }}</span>
            </p>
          </div>
        </li>
      </ul>
      <div class="meal">
        <p class="title">套餐信息（第一天）<a style="color: var(--basic-labe)" @click="$router.push({name: 'guidanceDetails'})" href="javascript:;">查看更多</a></p>
        <div>
          <div class="borderDiv">
            <div v-for="food in mealInfo.provideOrderMealss" :key="food.id">
              <div class="container" v-if="food.guidanceMeal && food.list.length > 0">
                <div>
                  <span v-if="food.guidanceMeal === 'breakfast'">早餐</span>
                  <span v-if="food.guidanceMeal === 'lunch'">午餐</span>
                  <span v-if="food.guidanceMeal === 'dinner'">晚餐</span>
                  <span v-if="food.guidanceMeal === 'breakfastAdd'">早加餐</span>
                  <span v-if="food.guidanceMeal === 'lunchAdd'">午加餐</span>
                  <span v-if="food.guidanceMeal === 'dinnerAdd'">晚加餐</span>
                </div>
                <div>
                  <span>{{ food.dinnerTime }}</span>
                </div>
                <div>
                  <span v-for="(item, index) in food.list" :key="item.id">
                    {{ index == food.list.length - 1 && item.name || (item.name + '，') }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="food">
         <p class="title">食物信息（单位：克）</p>
        <div class="content" >
          <div v-for="food in mealInfo.dayFoodTotal" :key="food.id">
            <span>{{ food.foodName }}</span>
            <p>{{ food.foodTotalNumber }}</p>
          </div>
        </div>
      </div>
      <div class="nutrition">
        <p class="title">营养信息</p>
        <div class="content" >
          <div v-if="mealInfo.calculation">
            <span>能量：{{ towNumber(mealInfo.calculation.foodEnergy) }}kcal</span>
            <span>碳水：{{ towNumber(mealInfo.calculation.foodCarbohydrate) }}g</span>
            <span>蛋白质：{{ towNumber(mealInfo.calculation.foodProtein) }}g</span>
            <span>脂肪：{{ towNumber(mealInfo.calculation.foodFat) }}g</span>
          </div>
        </div>
      </div>
      <van-form @submit="onSubmit">
        <div class="cateringDay">
          <p>配餐天数: {{ orderInfo.guidanceExecuteDays }} 天</p>
          <p>
            <span></span>
            <van-field disabled :rules="[{ required: true, message: '请选择配餐日期' }]" @click="dateTimeShow = true" v-model="cateringDay" label="配餐日期" placeholder="请选择开始配餐日期" />
            <van-cell-group inset>
              <van-overlay :show="dateTimeShow" @click="dateTimeShow = false">
              <div class="wrapper" @click.stop>
                <van-datetime-picker
                  v-if="dateTimeShow"
                  v-model="currentDate"
                  type="date"
                  title="选择开始配餐日期"
                  @confirm="dateConfirm"
                  @cancel="dateTimeShow = false"
                  :min-date="minDate"
                  style="position: fixed; width: 100%; bottom: 0;"
                />
              </div>
            </van-overlay>
            </van-cell-group>
          </p>
          <p>
            <van-cell-group inset>
              <van-field :rules="[{ required: true, message: '请填写配送地址' }]" v-model="address" label="配送地址" placeholder="请选择配送地址" />
            </van-cell-group>
          </p>
          <p>
            <van-cell-group inset>
              <van-field
                v-model="remark"
                rows="3"
                autosize
                label="备注信息"
                type="textarea"
                placeholder="请输入备注"
              />
            </van-cell-group>
          </p>
        </div>
      <div>
        <div class="totalContent">
          <p class="title">处方支付金额</p>
          <p>
            <span style="color: var(--basic-green)">金额：</span>
            <span>￥{{ orderInfo.orderAmount || 0 }}</span>
            <span
              v-if="orderInfo.orderStatus === 1"
              style="color: var(--basic-red)"
              >已支付</span
            >
            <span
              v-if="orderInfo.orderStatus === 2"
              style="color: var(--basic-red)"
              >已配送</span
            >
            <span
              v-if="orderInfo.orderStatus === 3"
              style="color: var(--basic-green)"
              >停止配送</span
            >
            <span v-if="orderInfo.orderStatus === 6">支付中</span>
            <span v-if="orderInfo.orderStatus === 7">发起退款</span>
            <span v-if="orderInfo.orderStatus === 8">已退款</span>
          </p>
        </div>
      <div class="btnContent">
        <van-button
          v-if="orderInfo.orderStatus !== 1"
          round
          size="small"
          type="success"
          native-type="submit"
          >立即支付</van-button
        >
      </div>
      </div>
      </van-form>
      <div class="seeInfoContent">
        <van-button
          @click="seeInfo"
          round
          size="small"
          type="success"
          >查看更多处方信息</van-button
        >
      </div>
      </div>
  </div>
</template>
<script>
import { requestGuidance } from "@/api/guidance/guidance"
import { reactive, toRefs } from "vue";
import moment from "moment";
import { useRoute, useRouter } from "vue-router";
import { DatetimePicker } from 'vant';

export default {
  setup() {
    const route = useRoute();
    const router = useRouter();
    const today = new Date();
    const tomorrow = today.setTime(today.getTime()+24*60*60*1000)
    const state = reactive({
      orderInfo: "",
      id: route.params.id,
      mealInfo: [],
      cateringDay:'',
      currentDate: '',
      dateTimeShow: false,
      remark: '',
      minDate: new Date(tomorrow),
      address: '',
      foodInfoData: [],
    });
    requestGuidance({ id: state.id }).then(v => {
      const { data } = v;
      const foodCalculate = data.foodCalculate;
      state.orderInfo = data;
      data.provideOrderDay.forEach((value, index) => {
        const calculation = {
          foodStatistics:{
            beans: 0,
            egg: 0,
            fruits: 0,
            meat: 0,
            milk: 0,
            nut: 0,
            oilOrfat: 0,
            other: 0,
            stapleFood: 2860,
            vegetable: 0,
          },
          foodEnergy: 0,
          foodFat: 0,
          foodCarbohydrate: 0,
          foodProtein: 0,
          foodStatisticsList: [],
        }
        value.dayFoodTotal = JSON.parse(value.dayFoodTotal);
        value.dayFoodIntake = JSON.parse(value.dayFoodIntake);
        value.provideOrderMealss.forEach(food => {
          food.list.forEach(guidanceMeal => {
            calculation.foodStatisticsList.push(JSON.parse(guidanceMeal.foodStatistics)[0]);
            calculation.foodEnergy += guidanceMeal.foodEnergy
            calculation.foodFat += guidanceMeal.foodFat
            calculation.foodCarbohydrate += guidanceMeal.foodCarbohydrate
            calculation.foodProtein += guidanceMeal.foodProtein
          })
        })
        // 计算食物
        calculation.foodStatisticsList.forEach(foodStatistics => {
          calculation.foodStatistics.beans += foodStatistics.beans
          calculation.foodStatistics.fruits += foodStatistics.fruits
          calculation.foodStatistics.egg += foodStatistics.egg
          calculation.foodStatistics.meat += foodStatistics.meat
          calculation.foodStatistics.milk += foodStatistics.milk
          calculation.foodStatistics.nut += foodStatistics.nut
          calculation.foodStatistics.oilOrfat += foodStatistics.oilOrfat
          calculation.foodStatistics.other += foodStatistics.other
          calculation.foodStatistics.stapleFood += foodStatistics.stapleFood
          calculation.foodStatistics.vegetable += foodStatistics.vegetable
        })
        value.dayFoodTotal.forEach(foodTotal => {
          let foodTotalNumber = null;
          calculation.foodStatisticsList.forEach(foodStatistics => {
            for(let i in foodStatistics) {
              if (i === 'stapleFood' && foodTotal.id === 1) {
                console.log(i, foodStatistics[i]);
                foodTotalNumber += foodStatistics[i];
                foodTotal.foodTotalNumber = foodTotalNumber;
              } else if (i === 'vegetable' && foodTotal.id === 2) {
                foodTotalNumber += foodStatistics[i];
                foodTotal.foodTotalNumber = foodTotalNumber;
              } else if (i === 'meat' && foodTotal.id === 3) {
                foodTotalNumber += foodStatistics[i];
                foodTotal.foodTotalNumber = foodTotalNumber;
              } else if (i === 'egg' && foodTotal.id === 4) {
                foodTotalNumber += foodStatistics[i];
                foodTotal.foodTotalNumber = foodTotalNumber;
              } else if (i === 'milk' && foodTotal.id === 5) {
                foodTotalNumber += foodStatistics[i];
                foodTotal.foodTotalNumber = foodTotalNumber;
              } else if (i === 'beans' && foodTotal.id === 6) {
               foodTotalNumber += foodStatistics[i];
                foodTotal.foodTotalNumber = foodTotalNumber;
              } else if (i === 'oilOrfat' && foodTotal.id === 7) {
                foodTotalNumber += foodStatistics[i];
                foodTotal.foodTotalNumber = foodTotalNumber;
              } else if (i === 'fruits' && foodTotal.id === 8) {
                foodTotalNumber += foodStatistics[i];
                foodTotal.foodTotalNumber = foodTotalNumber;
              } else if (i === 'nut' && foodTotal.id === 9) {
                foodTotalNumber += foodStatistics[i];
                foodTotal.foodTotalNumber = foodTotalNumber;
              } else if (i === 'other' && foodTotal.id === 10) {
                foodTotalNumber += foodStatistics[i];
                foodTotal.foodTotalNumber = foodTotalNumber;
              }
            }
          })
          console.log(foodTotal);
        });

        console.log(calculation);
        value.calculation = calculation;
      })
      state.mealInfo = data.provideOrderDay[0]
      console.log(data);
    })

    // 保留两位小数
    const towNumber = (val) => {
      if (typeof val === 'number') {
        return val.toFixed(2);
      } else {
        return parseFloat(val).toFixed(2);
      }
    };
    // 时间格式
    const formatter = (type, val) => {
      if (type === 'year') {
        return `${val}年`;
      }
      if (type === 'month') {
        return `${val}月`;
      }
      return val;
    };
    // 选择时间回调
    const dateConfirm = (e) => {
      const cateringDay =  moment(e).format('YYYY-MM-DD');
      state.cateringDay = cateringDay;
      state.dateTimeShow = false;
    }
    // 查看更多处方信息
    const seeInfo = () => {
      window.location.href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzg2NDUyNjA4Mw==&scene=110#wechat_redirect"
    }
    // 支付方法
    const onSubmit = (val) => {
      console.log(val);
      const { webBaseUrl, orderNo } = state.orderInfo;
      const { address, cateringDay, remark } = state; 
      const payUrl = `/api/restaurant/orderApi/payer/${orderNo}/${cateringDay}/${address}/${remark}`
      window.location.href = webBaseUrl + payUrl;
    };

    const openUsage = () => {
      router.push({ path: '/prescription/usage', query: {id: state.orderInfo.medicalAdviceId}})
    }

    // 开具发票
    const openInvoice = () => {
      localStorage.setItem('changeAdviceCode', state.orderInfo.medicalAdviceCode)
      router.push({path: 'invoice'})
    };

    return {
      ...toRefs(state),
      onSubmit,
      requestGuidance,
      openInvoice,
      openUsage,
      seeInfo,
      dateConfirm,
      formatter,
      towNumber
    };
  },
};
</script>
<style lang="scss" scoped>
.nutrition {
  opacity: .7;
  .content {
    display: flex;
    justify-items: center;
    padding: 5px 10px;
    span {
      margin-right: 10px;
    }
  }
}
.food {
  opacity: .7;
  .title {
    border-bottom: none!important;
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    padding: 0 10px;
    border: none;
    div {
      border: 1px solid var(--basic-border-color);
      width: 16%;
      text-align: center;
      span {
        display: inline-block;
        width: 100%;
        padding: 5px 0;
        border-bottom: 1px solid var(--basic-border-color);
      }
      p {
        padding: 8px 0;
      }
    }
  }
  p, span {

  }
}
.cateringDay {
  p:first-of-type {
    padding: 16px;
    color: #646566;
  }
}
.meal {
  opacity: 0.7;
  .borderDiv {
    border: 1px solid var(--basic-border-color);
    border-bottom: none;
    padding: 5px;
  }
  .container {
    display: flex;
    div {
      border-bottom: 1px solid var(--basic-border-color);
    }
    div:first-of-type {
      width: 20%;
      display: flex; 
      align-items: center;
      justify-content:center;
      border-right: 1px solid var(--basic-border-color);
    }
    div:nth-of-type(2) {
      width: 20%;
      display: flex; 
      align-items: center;
      justify-content:center;
      border-right: 1px solid var(--basic-border-color);
    }
    div:last-of-type {
      width: 70%;
      padding: 5px;
      display: flex;
      justify-items: center;
      flex-wrap: wrap;
      span {
        padding: 5px 0;
      }
    }
  }
}
.content {
  border: 1px solid var(--basic-border-color);
  border-top: none;
  .totalContent {
    .title {
      opacity: 0.5;
    }
    p:last-of-type {
      background: var(--basic-price);
      padding: 16px;
      // background: ;
      text-align: left;
      span {
        font-size: 17px;
        display: inline-block;
        width: 32%;
      }
    }
  }
  .title {
    height: 40px;
    padding-left: 10px;
    line-height: 40px;
    border-bottom: 1px solid var(--basic-border-color);
    span {
      padding: 2px 10px;
      border-radius: 10px;
      color: #fff;
      font-size: 12px;
      background: var(--basic-green);
    }
  }
  ul {
    li {
      padding: 16px;
      border-bottom: 1px solid var(--basic-border-color);
      span:first-of-type {
        color: var(--basic-labe);
      }
      div {
        display: flex;
        p {
          flex: 1;
        }
      }
    }
  }
}
.btnContent {
   padding: 20px 20px 0 20px;
  text-align: center;
  button {
    width: 50%;
    display: block;
    margin: 0 auto;
    margin-bottom: 10px;
  }
}
.seeInfoContent {
  padding: 10px 20px 20px 20px;
  text-align: center;
    button {
    width: 50%;
    display: block;
    margin: 0 auto;
    margin-bottom: 10px;
  }
}
</style>
